// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ff3j","location":"Header_location__1BuFr"};